import { useCallback } from "react"
import {
  Button,
  HeadingXSmall,
  ListItem,
  ListItemLabel,
  ParagraphMedium,
  useStyletron,
} from "@mezo-org/mezo-clay"
import { useNavigate } from "@tanstack/react-router"

import { setOpenModal, useDappDispatch } from "#/redux-state"
import { routes } from "#/shared/constants"

export default function MarketSurvey() {
  const [css, theme] = useStyletron()

  const navigate = useNavigate()
  const dispatch = useDappDispatch()

  const buttonClickHandler = useCallback(() => {
    dispatch(setOpenModal("store-feedback"))
    navigate({ to: `${routes.STORE}?feedback=true` })
  }, [dispatch, navigate])

  const surveyButton = () => (
    <Button onClick={buttonClickHandler} size="medium">
      Take survey
    </Button>
  )

  return (
    <ListItem
      endEnhancer={surveyButton}
      overrides={{
        Root: {
          style: () => ({
            borderRadius: theme.borders.radius400,
            marginTop: theme.sizing.scale1600,
            padding: 0,
          }),
        },
        Content: {
          style: () => ({
            paddingInline: theme.sizing.scale800,
            paddingTop: theme.sizing.scale500,
            paddingBottom: theme.sizing.scale500,
          }),
        },
      }}
    >
      <ListItemLabel
        description={
          <ParagraphMedium
            as="span"
            className={css({
              color: theme.colors.contentSecondary,
              display: "block",
            })}
          >
            Take our quick survey and share your wishlist!
          </ParagraphMedium>
        }
      >
        <HeadingXSmall
          as="span"
          className={css({
            marginBottom: theme.sizing.scale100,
            display: "block",
          })}
        >
          Help shape the future—tell us how you&apos;d spend your MUSD!
        </HeadingXSmall>
      </ListItemLabel>
    </ListItem>
  )
}
